import { lang } from '@umu/ukit-lang';
/**
 * @dedsc 剪切板按钮
 * @author Kody
 */

import React, { useEffect, useState } from 'react';
import Clipboard from '@umu/umu-clipboard';
import { Toast } from 'common/src/services';

interface IProps {
    text?: string;
    value: string;
    label: string;
    className: string;
    successToast?: string;
    failToast?: string;
    children?: JSX.Element;
}

import './clipBoardBtn.scss';
export const ClipBoardBtn = (props: IProps) => {
    const { label, value, className, successToast, text, failToast, children } = props;
    const [isSupported, setIsSupported] = useState(false);
    const btnClassName = `j_do-clip-${className}`;
    useEffect(() => {
        const canDo = Clipboard.isSupported();
        setIsSupported(canDo);
        if (canDo) {
            const clipboard = new Clipboard(`.${btnClassName}`);
            clipboard.on('success', () => {
                Toast.show({
                    message: successToast || lang('复制成功'),
                    duration: 1000,
                });
            });
            clipboard.on('error', () => {
                Toast.show({
                    message: failToast || lang('访问码复制失败，请手动复制访问码'),
                });
            });
        }
    }, []);

    const render = () => {
        return (
            <div className={`clipboard-btn ${btnClassName}`} data-clipboard-text={value}>
                <span className="value">{text === undefined ? value : text}</span>
                {children}
                {isSupported ? <label>{label}</label> : null}
            </div>
        );
    };
    return render();
};
